import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getPopUpList, PopUpRequest } from '../api/popUpPromotion'
import { SiteConfigState } from './siteConfigSlice'
import { PopUpType } from 'booker'

export type PopUpWrapper = {
   isOpen: boolean,
   hasBeenShown: boolean,
   value: PopUpType,
   alreadyAplied: boolean
}

export type PopUpListWrapper = {
   isPristine: boolean
   isFetching: boolean
   data: Array<PopUpWrapper> | null
   hasError: boolean
}

const initialState: PopUpListWrapper = {
   isPristine: true,
   isFetching: false,
   data: null,
   hasError: false
}

export const getPopUpListThunk = createAsyncThunk(
   'getPopUpList',
   async (
      request: Omit<PopUpRequest, 'language' | 'audience'>,
      { rejectWithValue, getState },
   ) => {
      const { siteConfig } = getState() as { siteConfig: SiteConfigState }
      // En el widget no sabemos si es loyalty member o no por lo que siempre se envía el audience como ALL_VISITORS.
      const response = await getPopUpList({ ...request, language: siteConfig.data?.language, audience: 'ALL_VISITORS' })
      // if (response) {
      //    const alreadyAplied = request && request.promotionCode && request.promotionCode !== "" ? true : false;
      //    return { response, alreadyAplied }
      // }
      if (response) {
         return response.map(popup => ({
            value: popup,
            alreadyAplied: request && request.promotionCode && request.promotionCode !== "" ? true : false,
         }))

         // return response
      }
      return rejectWithValue(null)
   },
)

export const getPopUpListSlice = createSlice({
   name: 'PopUpList',
   initialState,
   reducers: {
      clear: () => {
         return initialState
      },
      showPopUpPromotion: (state, action: PayloadAction<number>) => {
         const popup = state.data?.find(popup => popup.value?.id === action.payload)
         if (popup) {
            popup.isOpen = true
         }
      },
      closePopUpPromotion: (state, action: PayloadAction<number>) => {
         const popup = state.data?.find(popup => popup.value?.id === action.payload)
         if (popup) {
            popup.isOpen = false
            popup.hasBeenShown = true
         }
      },
      resetShown: (state, action: PayloadAction<number>) => {
         const popup = state.data?.find(popup => popup.value?.id === action.payload)
         if (popup) {
            popup.isOpen = false
            popup.hasBeenShown = false
            popup.alreadyAplied = false
         }
      },
      seedPlayground: (state, action: PayloadAction<PopUpType[]>) => {
         state.isPristine = false
         state.isFetching = false
         state.hasError = false
         state.data = action.payload.map((value) => ({
            isOpen: false,
            hasBeenShown: false,
            alreadyAplied: false,
            value,
         }))
      }
   },
   extraReducers(builder) {
      builder.addCase(getPopUpListThunk.pending, (state) => {
         state.isPristine = false
         state.isFetching = true
         state.hasError = false
      })
      builder.addCase(getPopUpListThunk.fulfilled, (state, action) => {
         state.isPristine = false
         state.isFetching = false
         state.hasError = false
         state.data = action.payload.map((popup) => ({
            isOpen: false,
            hasBeenShown: false,
            alreadyAplied: popup.alreadyAplied,
            value: popup.value
         }))
      })
      builder.addCase(getPopUpListThunk.rejected, (state) => {
         state.isPristine = false
         state.isFetching = false
         state.hasError = true
      })
   },
})
export const { clear, resetShown, showPopUpPromotion, closePopUpPromotion, seedPlayground } = getPopUpListSlice.actions
export default getPopUpListSlice.reducer
